import { MouseEvent, type RefObject } from 'react';

import { Chip, type ChipProps } from '@mint-lib/tw-components';
import { Chat } from '@mint-sdk/api-ai-assistant';

import ActionPopover from './ActionPopover.jsx';

type Props = {
  status: Chat.ChatItemType['status'];
  isHovered: boolean;
  isMobile?: boolean;
  selected?: boolean;
  childRef: RefObject<HTMLButtonElement | null>;
  onHideActionIcon: () => void;
  onDeleteChat: (e: MouseEvent<HTMLButtonElement>) => void;
  onClickUpdateChatName: (e: MouseEvent<HTMLButtonElement>) => void;
};

const statusConfig: Record<
  NonNullable<Chat.ChatItemType['status']>,
  { color: ChipProps['color']; label: string }
> = {
  active: { color: 'success', label: 'Active' },
  scheduled: { color: 'info', label: 'Scheduled' },
  expired: { color: 'error', label: 'Expired' },
};

const ChatItemEndAdornment = ({
  status,
  isHovered,
  isMobile,
  selected,
  childRef,
  onHideActionIcon,
  onDeleteChat,
  onClickUpdateChatName,
}: Props) => {
  const showActions = (isMobile && selected) || isHovered;

  if (showActions) {
    return (
      <ActionPopover
        ref={childRef}
        onHideActionIcon={onHideActionIcon}
        onDeleteChat={onDeleteChat}
        onClickUpdateChatName={onClickUpdateChatName}
      />
    );
  }

  if (status && statusConfig[status]) {
    const { label, color } = statusConfig[status];

    return (
      <Chip color={color} size="small" variant="outline">
        {label}
      </Chip>
    );
  }

  return null;
};

export default ChatItemEndAdornment;
